import React from "react";
import {registerQubeLiteUser} from "../utils/api.utils";

export const NewAccount = ({renderErrorMessage, signupEmail, subdomain, setErrorMessage, finishUp}) => {
    const [email, setEmail] = React.useState(signupEmail);
    const [firstName, setFirstName] = React.useState('');
    const [lastName, setLastName] = React.useState('');
    const [password, setPassword] = React.useState('');

    const browserTimezone = moment.tz.guess();

    const createFirstUser = () => {

        return registerQubeLiteUser(subdomain, email, password, firstName, lastName, browserTimezone)
            .then(({data}) => {
                finishUp();
            }).catch((error) => {
                if (error.data) {
                    setErrorMessage(error.data.errors);
                } else {
                    setErrorMessage(error.errors);
                }
            });
    }

    return <div className={"step flexRowContainer"} id="step1">
        <div>
            <div><h3 className={"mb10"}>Almost there!</h3>
                Let's create an account for you in your new workspace.
            </div>
            <div className="flexColumnContainer">
                <div className="flexRowContainer flexFill pt10">
                    <input type="text" name="firstName" required className="fancyInput" value={firstName}
                           onChange={(e) => setFirstName(e.target.value)}/>
                    <label alt='First Name'
                           placeholder='First Name'/>
                </div>

                <div className="flexRowContainer flexFill pt10">
                    <input type="text" name="lastName" required className="fancyInput" value={lastName}
                           onChange={(e) => setLastName(e.target.value)}/>
                    <label alt='Last Name'
                           placeholder='Last Name'/>
                </div>
            </div>

            <div className="flexRowContainer flexFill pt10">
                <input type="text" name="username" required className="fancyInput" value={email}
                       onChange={(e) => setEmail(e.target.value)}/>
                <label alt='Your email'
                       placeholder='Your email'/>
            </div>
            <div className="flexRowContainer flexFill pt10">
                <input type="password" name="pasword" required className="fancyInput" value={password}
                       onChange={e => setPassword(e.target.value)}/>
                <label alt='Your password'
                       placeholder='Your password'/>
            </div>
            {renderErrorMessage()}
            <div className={"flexColumnContainer"}>
                <div className={"flexFill"}/>
                <input type="button" className="btn setupBtn" value="Register"
                       onClick={createFirstUser}/></div>

        </div>
    </div>
};